import { getObjectUtil } from 'packages/src'
import WORKOUT_EXERCISES_PATH from '../../constants/path'
import { createSelector } from 'reselect'

const getCurrentSetIndexWorkoutExerciseSelect = createSelector(
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.CURRENT_SET_INDEX),
  (setDataIndex) => setDataIndex || 0
)

export default getCurrentSetIndexWorkoutExerciseSelect
